export class Utils {
    public static createCanvasFromImage(img: HTMLImageElement | HTMLImageElement[], x: number, y: number, width: number, height: number): HTMLCanvasElement {
        // Create canvas
        let canvas: HTMLCanvasElement = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;

        // Draw image(s) on canvas
        if (img.constructor === Array) {
            let imgs = <HTMLImageElement[]> img;
            for (const img of imgs) {
                canvas.getContext('2d').drawImage(img, x, y, width, height, 0, 0, width, height);
            }
        } else {
            img = <HTMLImageElement> img;
            canvas.getContext('2d').drawImage(img, x, y, width, height, 0, 0, width, height);
        }

        return canvas;
    }

    public static downloadCanvasPNG(canvas: HTMLCanvasElement, name: string): void {
        const temp = <HTMLAnchorElement>document.getElementById('DOM-attached-download');
        const fileName = name + '.png';

        if (canvas.msToBlob) { // MS Edge support
            const blob = canvas.msToBlob();
            window.navigator.msSaveBlob(blob, fileName);
        } else {
            temp.href = canvas.toDataURL();
            temp.download = fileName;
            temp.click();
        }
    }

    public static downloadCanvasSVG(canvasSVG: string, name: string): void {
      const temp = <HTMLAnchorElement>document.getElementById('DOM-attached-download');
      temp.href = canvasSVG;
      temp.download = name + '.svg';
      temp.click();
    }

    public static regexAllMatches(regex: RegExp, str: string, group: number = 0): string[] {
        let matches: string[] = [];
        let match: RegExpExecArray;
        do {
          match = regex.exec(str);
          if (match) {
            matches.push(match[group]);
          }
        } while (match);

        return matches;
      }
}



// WEBPACK FOOTER //
// ./src/app/lib/Utils.ts